import { useCallback } from 'react';
import { useData } from '@/common/dataContext';
import Configs from '@/Configs';

/**
 * Hook to provide functions for adding different types of toast messages.
 * @returns {{
 *   errorToast: (message: string) => void,
 *   successToast: (message: string) => void,
 *   warningToast: (message: string) => void,
 *   infoToast: (message: string) => void
 * }}
 */
export const useToastMessage = () => {
  const { addToast } = useData();

  const errorToast = useCallback((message) => {
    addToast({ message, type: Configs.errorToaster });
  }, [addToast]);

  const successToast = useCallback((message) => {
    addToast({ message, type: Configs.successToaster });
  }, [addToast]);

  const warningToast = useCallback((message) => {
    addToast({ message, type: Configs.warningToaster });
  }, [addToast]);

  const infoToast = useCallback((message) => {
    addToast({ message, type: Configs.infoToaster });
  }, [addToast]);

  return { errorToast, successToast, warningToast, infoToast };
};
